module.exports = __webpack_public_path__ + "media/images/folder-bee47fba673e852c4c0fb82060bb9812.svg";